import GoogleLoginPage from "../../src/containers/Authentication/googleLogin"
import ChangePassword from "../../src/containers/Authentication/changePassword"

import DashboardLayout from "../../src/components/dashboard/DashboardLayout"
import BrowseUser from "containers/CasAppUsersList/browseUsers"

import BrowseRoles from "containers/Roles/browseRoles"
import BrowsePermissions from "containers/Permissions/browsePermissions"
import ForgetPasswordPage from "containers/Authentication/forgetPassword"
import Home from "containers/Dashboard/home"
import Logout from "containers/Authentication/logout"

const authProtectedRoutes = [
  {
    title: "Dashboard",
    key: "dashboard",
    icon: "far fa-window-maximize",
    showInSidebar: true,
    component: Home,
    path: "/dashboard/home",
    roles: [1, 2, 3, 6, 7],
    permissions: [
      "VIEW_BROWSE_CONTENT",
      "EDIT_BROWSE_CONTENT",
      "VIEW_MANAGE_CONTENT",
    ],
  },
  {
    title: "Browse User",
    key: "browseuser",
    icon: "far fa-window-maximize",
    showInSidebar: true,
    component: BrowseUser,
    path: "/user/browse",
    roles: [1, 2, 3, 6, 7],
    permissions: [
      "VIEW_BROWSE_CONTENT",
      "EDIT_BROWSE_CONTENT",
      "VIEW_MANAGE_CONTENT",
    ],
  },
  {
    title: "Browse Roles",
    key: "browseroles",
    icon: "far fa-window-maximize",
    showInSidebar: true,
    component: BrowseRoles,
    path: "/roles/browse",
    roles: [1, 2, 3, 6, 7],
    permissions: [
      "VIEW_BROWSE_CONTENT",
      "EDIT_BROWSE_CONTENT",
      "VIEW_MANAGE_CONTENT",
    ],
  },
  {
    title: "Browse Permissions",
    key: "browsePermissions",
    icon: "far fa-window-maximize",
    showInSidebar: true,
    component: BrowsePermissions,
    path: "/permissions/browse",
    roles: [1, 2, 3, 6, 7],
    permissions: [
      "VIEW_BROWSE_CONTENT",
      "EDIT_BROWSE_CONTENT",
      "VIEW_MANAGE_CONTENT",
    ],
  },
  {
    title: "Log Out",
    key: "log_out",
    showInSidebar: false,
    component: Logout,
    path: "/api/auth/logout",
  },
  {
    path: "/change-password",
    key: "change_password",
    showInSidebar: false,
    title: "Change Password",
    component: ChangePassword,
  },
]
const publicRoutes = [
  // { path: "/internal-logout", key: "internal_logout", title: "Logout", component: GoogleLoginPage },
  {
    path: "/forgot-password",
    key: "forgot_password",
    title: "Forgot Password",
    component: ForgetPasswordPage,
  },
  // {
  //     path: "/change-password",
  //     key: "change_password",
  //     title: "Change Password",
  //     component: ChangePassword,
  // },
  {
    path: "/dashboard",
    key: "dashboard",
    title: "Dashbaord",
    component: DashboardLayout,
  },
  {
    path: "/user/browse",
    key: "browseuser",
    title: "Browse User",
    component: BrowseUser,
  },
  { path: "/login", key: "login", title: "Login", component: GoogleLoginPage },
  //{ path: "/api/auth/logout", key: "log_out", title: "Logout", component: Logout },
  // { path: "/internal-login", key: "internal_login", title: "Internal Login", component: GoogleLoginPage },
]

export { authProtectedRoutes, publicRoutes }
